export default class HorariosProxi {
    constructor(axios, url) {
        this.axios = axios;
        this.url = url;
    }
    create(params) {
        return this.axios.post(this.url + '/horarios', params);
    }

    getListaHorarios() {
        return this.axios.get(this.url + `/horarios/lista`);
    }

    remove(id) {
        return this.axios.delete(this.url + `/horarios/${id}`);
      }
    

      //-----------------------------------------PUNTOS DE ATERRISAJE HORA DE HORARIOS-------------------------

  getAllHora(page, take) {
    return this.axios.get(this.url + `/hora?page=${page}&take=${take}`);
  }

  getListaHora() {
    return this.axios.get(this.url + `/hora/lista`);
  }

  createHora(params) {
    return this.axios.post(this.url + "/hora", params);
  }

  updateHora(id, params) {
    return this.axios.put(this.url + `/hora/${id}`, params);
  }

  removeHora(id) {
    return this.axios.delete(this.url + `/hora/${id}`);
  }

  async queryHora(querys) {
    return await this.axios.get(this.url + `/hora/query?querys=${querys}`);
  }
}